var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 430.905,
    height: 326.997,
    viewBox: "0 0 430.905 326.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "matrix(0.996, 0.087, -0.087, 0.996, -631.215, -593.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M109.5,49.074,424,33.641l-48,160.4L59.142,214.736Z",
    transform: "matrix(0.848, -0.53, 0.53, 0.848, 627, 704.124)",
    fill: "#fff",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M56.518,7.32,205.682,0l-27.35,92.036L30.391,93.221Z",
    transform: "matrix(0.848, -0.53, 0.53, 0.848, 901.973, 711.447)",
    fill: "#fff",
    opacity: 0.05
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape2);
export default __webpack_public_path__ + "static/media/shape-2.22372503564e099552086cc6887cfefe.svg";
export { ForwardRef as ReactComponent };